import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Grid, Card, InputLabel, MenuItem, Select, Button, Typography, Box
} from '@mui/material';
import SoftInput from "components/SoftInput";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { CustomSelect } from 'admin/components/atoms';
import dummyLogo from '../../../assets/images/dummyImage.png'
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import SoftButton from 'components/SoftButton';

const validationSchema = Yup.object({
    subcategoryName: Yup.string().required('SubCategory name is required'),
    logo: Yup.mixed().required('Logo is required'),
});

const CreateSubCategoryForm = () => {
    const queryString = window.location.search;
    const query = new URLSearchParams(queryString);
    const parentCategory = query.get("parentCategory");
    const [preview, setPreview] = useState(null);
    const params = useParams()
    const navigate = useNavigate()
    const formik = useFormik({
        initialValues: {
            subcategoryName: '',
            logo: null,
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const formData = new FormData();
                formData.append('name', values.subcategoryName);
                formData.append('parentCategory', parentCategory);

                // Only append logo if user selected a file
                if (values.logo) {
                    formData.append('logo', values.logo);
                }

                const response = params?.id
                    ? await service.categories.edit(params?.id, formData)
                    : await service.categories.add(formData);

                if (response.status === 200 || response.status === 201) {
                    navigate(-1);
                    toast.success(response?.data?.message);
                } else {
                    toast.error(response?.data?.message);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message);
                console.error('Submission error:', error);
            }
        },
    });

    const handleFileChange = (event) => {
        const file = event.currentTarget.files[0];
        formik.setFieldValue('logo', file);
        if (file) {
            setPreview(URL.createObjectURL(file));
        }
    };


    const getDetailById = async () => {
        try {
            let response = await service.categories.getDetailById(params.id)
            console.log("asdasdDataData", response?.data?.data)
            if (response?.data?.data) {
                // let Data =  response?.data?.data.find((item) => item?._id === row?.category);
                formik.setValues({
                    subcategoryName: response?.data?.data?.name,
                    logo: response?.data?.data?.logo,
                })
                setPreview(response?.data?.data?.logo)
            }

        } catch (error) {

        }
    }

    useEffect(() => {

        if (params?.id) {
            getDetailById()
        }
    }, [])
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox mt={3}>
                <Card className="glassmorphism-card"
                    sx={{
                        // width: 470,
                        display: "flex",
                        minHeight: 'auto',
                        flexDirection: "column",
                        // justifyContent: "center",
                        // alignItems: "center",
                        padding: 2,
                        boxShadow: 2,

                    }}>
                    <SoftTypography variant="h6" fontWeight="bold" gutterBottom>Create Sub Category</SoftTypography>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Subcategory Name<span style={{ color: 'red' }}>*</span></SoftTypography>
                                <SoftInput
                                    name="subcategoryName"
                                    placeholder="Enter Subcategory"
                                    value={formik.values.subcategoryName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.subcategoryName && Boolean(formik.errors.subcategoryName)}
                                />
                                {formik.touched.subcategoryName && formik.errors.subcategoryName && (
                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                        {formik.errors.subcategoryName}
                                    </SoftTypography>
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Upload logo<span style={{ color: 'red' }}>*</span></SoftTypography>
                                {<Box component="img" src={preview || dummyLogo} sx={{ height: 80, mb: 1 }} />}
                                <div>
                                    <input
                                        type="file"
                                        name="logo"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                    />
                                    {formik.touched.logo && formik.errors.logo && (
                                        <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                            {formik.errors.logo}
                                        </SoftTypography>
                                    )}

                                </div>
                            </Grid>

                            <Grid item xs={12} display="flex" gap={2}>
                                <SoftButton type="submit" variant="gradient" color="info">Submit</SoftButton>
                                {/* <Button variant="outlined" onClick={()=> navigate(-1)}>Cancel</Button> */}
                                <SoftButton

                                    variant="outlined"
                                    color="info"
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </SoftButton>
                            </Grid>
                        </Grid>
                    </form>
                </Card>
            </SoftBox>
        </DashboardLayout>
    );
};

export default CreateSubCategoryForm;
